import React from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';
import { HiHome, HiCreditCard, HiUser } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

interface TabBarProps {
  selectedTab: string;
}

interface TabItemProps {
  value: string;
  icon: React.ReactNode;
  label: string;
  isSelected: boolean;
  onClick: () => void;
}

const TabItem: React.FC<TabItemProps> = ({ value, icon, label, isSelected, onClick }) => {
  return (
    <Box
      as="button"
      onClick={onClick}
      flex={1}
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      gap={2}
      border="none"
      bg={isSelected ? 'teal.100' : 'transparent'}
      cursor="pointer"
      transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
      py={2}
      px={2.5}
      borderRadius="xl"
      color={isSelected ? 'teal.600' : 'gray.500'}
      fontWeight={isSelected ? 'semibold' : 'normal'}
      transform={isSelected ? 'scale(1.08)' : 'scale(1)'}
      _hover={{
        bg: 'teal.100',
        transform: 'scale(1.04)',
      }}
      _active={{
        transform: 'scale(0.96)',
      }}
    >
      <Box
        fontSize="1.5rem"
        lineHeight="1"
        transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
        flexShrink={0}
        display="flex"
        alignItems="center"
      >
        {icon}
      </Box>
      <Text
        fontSize="sm"
        fontWeight="medium"
        lineHeight="1"
        opacity={isSelected ? 1 : 0}
        width={isSelected ? 'auto' : '0'}
        overflow="hidden"
        whiteSpace="nowrap"
        transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
        flexShrink={0}
        display="flex"
        alignItems="center"
      >
        {label}
      </Text>
    </Box>
  );
};

const TabBar: React.FC<TabBarProps> = ({ selectedTab }) => {
  const navigate = useNavigate();

  return (
    <Box
      position="fixed"
      bottom={0}
      left="50%"
      transform="translateX(-50%)"
      maxW="breakpoint-xl"
      width="100%"
      zIndex={10}
      userSelect="none"
    >
      <Flex
        bg="transparent"
        backdropFilter="blur(10px)"
        display="flex"
        justifyContent="space-around"
        alignItems="center"
        px={4}
        pt={2.5}
        pb={2.5}
        minH="60px"
      >
        <TabItem
          value="home"
          icon={<HiHome />}
          label="ホーム"
          isSelected={selectedTab === 'home'}
          onClick={() => navigate('/main/home')}
        />
        <TabItem
          value="payments"
          icon={<HiCreditCard />}
          label="支払い"
          isSelected={selectedTab === 'payments'}
          onClick={() => navigate('/main/payments')}
        />
        <TabItem
          value="profile"
          icon={<HiUser />}
          label="プロフィール"
          isSelected={selectedTab === 'profile'}
          onClick={() => navigate('/main/profile')}
        />
      </Flex>
      <Box bg="teal.50" h="env(safe-area-inset-bottom, 20px)" minH="20px" />
    </Box>
  );
};

export default TabBar;
